
import React from 'react';
const VideoOn = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-video"
        {...props}
    >
        <polygon points="23 7 16 12 23 17 23 7"></polygon>
        <rect x="1" y="5" width="15" height="14" rx="2" ry="2">
        </rect>
    </svg>
);
export default VideoOn;



